import { SessionState } from '@lendi/lala-react';
import { BaseEvent, EventCategory } from '@lendi/analytics-web';
import { WebAnalyticsWrapped, createWebAnalytics } from './createWebAnalytics';
import { InteractionType } from '@lendi/core-constants';

interface CustomEvent extends BaseEvent {
  question?: string;
  answer?: string;
  position?: string;
  text?: string;
}

export class TrackingService {
  private analytics: WebAnalyticsWrapped;

  constructor(category: EventCategory, session?: SessionState, analyticsWebV4?: boolean) {
    this.analytics = createWebAnalytics(category, session, analyticsWebV4);
  }

  async trackPage(name: string) {
    await this.analytics.trackPageLoad(name);
  }

  async trackEvent<T extends BaseEvent>(event: T) {
    await this.analytics.trackEventOccurred(event);
  }

  async trackCustomEvent<T extends CustomEvent>(event: T) {
    await this.analytics.trackEventOccurred(event);
  }

  async identityTracking(customerId?: string, flags?: any, userTraits?: any) {
    await this.analytics.trackCustomer(customerId, flags, userTraits);
  }
}

// Default instance
export const trackingService = new TrackingService(EventCategory.BOOK_APPOINTMENT);

export const getSelectionForEventTracking = (interactionType: InteractionType): string => {
  switch (interactionType) {
    case InteractionType.Store:
      return 'In-person (at store)';
    case InteractionType.FaceToFace:
      return 'In-person (another location)';
    case InteractionType.Video:
      return 'Video';
    default:
      return 'Phone';
  }
};
